var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: "VIEW_VULNERABILITY",
          expression: "'VIEW_VULNERABILITY'",
        },
      ],
      staticClass: "animated fadeIn",
      model: {
        value: _vm.tabIndex,
        callback: function ($$v) {
          _vm.tabIndex = $$v
        },
        expression: "tabIndex",
      },
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "occurrences",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: {
                active: _vm.tabIndex === 0,
                lazy: !_vm.visitedTabs.has(0),
              },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-shield" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("message.vulnerabilities_by_occurrence")
                          )
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("VulnerabilityAuditByOccurrence")],
            1
          ),
          _c(
            "b-tab",
            {
              ref: "grouped",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: {
                active: _vm.tabIndex === 1,
                lazy: !_vm.visitedTabs.has(1),
              },
              on: {
                click: function ($event) {
                  return _vm.routeTo("grouped")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-shield" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.grouped_vulnerabilities"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [_c("VulnerabilityAuditGroupedByVulnerability")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }